import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const FacebookDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.facebook9-16_svg__cls-1{fill:#fff}.facebook9-16_svg__cls-2{fill:#424242}.facebook9-16_svg__cls-5{fill:#eee}.facebook9-16_svg__cls-7{fill:#9e9e9e}'
        }
      </style>
    </defs>
    <g id="facebook9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="facebook9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path className="facebook9-16_svg__cls-1" d="M6.28 39.65h131.78v21.96H6.28z" />
        <path className="facebook9-16_svg__cls-2" d="M6.28 61.8h131.78v204.05H6.28z" />
        <path
          d="M138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
          fill="#1978f2"
        />
        <rect x={28.77} y={23.42} width={89.01} height={11.38} rx={5.69} fill="#0d56b3" />
        <circle className="facebook9-16_svg__cls-2" cx={18.79} cy={49.79} r={6.62} />
        <path className="facebook9-16_svg__cls-5" d="M29.15 44.96h34.37v3.94H29.15zM29.15 51.05h55.23v4.21H29.15z" />
        <path
          className="facebook9-16_svg__cls-1"
          d="M6.28 266.35v12.89a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-12.89z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <circle cx={22.33} cy={275.27} r={4.48} fill="#1878f2" />
        <circle className="facebook9-16_svg__cls-7" cx={55.6} cy={275.27} r={4.48} />
        <circle className="facebook9-16_svg__cls-7" cx={88.86} cy={275.27} r={4.48} />
        <circle className="facebook9-16_svg__cls-7" cx={122.12} cy={275.27} r={4.48} />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default FacebookDevice916;
